/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent } from '@material-ui/lab'
import { Typography, TableContainer, Table, TableBody, TableRow, TableCell, Paper, TableHead, Tooltip } from '@material-ui/core'
import { BubbleChart, Label, Category, ArrowRightAlt, Input, DeviceHub } from '@material-ui/icons'

import { format } from "date-fns";
import { zonedTimeToUtc } from 'date-fns-tz'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({
    cell_style : {
        width : '120px',
        maxWidth : '120px'
    }
})

const stages = {
    "Data Transfer" : {
        icon : Input
    },
    "Build Model" : {
        status_key : "model_initialization_status",
        status_object_key : "model_initialization_status_object",
        icon : BubbleChart,
    },
    "Label Samples" : {
        status_key : "labeling_status",
        status_object_key : "labeling_status_object",
        icon : Label
    },
    "Train" : {
        status_key : "training_status",
        status_object_key : "training_status_object",
        icon : Category
    }
}

const filters = {
    iu : {

    },
    operation : {

    },
    stage : {

    },
    status : {

    }
}

const state_colors = {
    Disabled : {
        color : "rgba(0,0,0,0.5)",
        class_name : "default",
        connector : {
            variant : "determinate",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Ready : {
        color : "#2296f3",
        class_name : "default",
        connector : {
            variant : "determinate",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Scheduled : {
        color : "#2296f3",
        class_name : "scheduled",
        connector : {
            variant : "buffer",
            value : 10,
            valueBuffer : 50,
            color : 'primary'
        }
    },
    InProgress : {
        color : "#2296f3",
        class_name : "in_progress",
        connector : {
            variant : "indeterminate",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    PartiallyCompleted : {
        color : "#2296f3",
        class_name : "default",
        connector : {
            variant : "determinate",
            value : 50,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Aborted : {
        color : "#dc004e",
        class_name : "default",
        connector : {
            variant : "buffer",
            value : 50,
            valueBuffer : 0,
            color : 'secondary'
        }
    },
    Completed : {
        color : "#4caf50",
        class_name : "in_progress",
        connector : {
            variant : "determinate",
            value : 100,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Dirty : {
        color : "rgba(0,0,0,0.5)",
        class_name : "default",
        connector : {
            variant : "determinate",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Queued : {
        color : "#2296f3",
        class_name : "default",
        connector : {
            variant : "buffer",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Timeout : {
        color : "rgba(0,0,0,0.5)",
        class_name : "default",
        connector : {
            variant : "determinate",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Unknown : {
        color : "rgba(0,0,0,0.5)",
        class_name : "default",
        connector : {
            variant : "indeterminate",
            value : 0,
            valueBuffer : 0,
            color : 'primary'
        }
    },
    Aborting : {
        color : "#dc004e",
        class_name : "default",
        connector : {
            variant : "buffer",
            value : 0,
            valueBuffer : 0,
            color : 'secondary'
        }
    }
}

class TimeLine extends Component {
    state = {}

    componentDidMount () {
        this.getTimeLineObject()
    }

    getTimeLineObject = () => {
        let timeline_list = []

        let iu_list = this.props.ic.information_units
        let training_status = this.props.ic.training_status_object
        let model_initialization_status = this.props.ic.model_initialization_status_object
        let label_status = this.props.ic.labeling_status_object

        iu_list.map(iu => {
            iu.data_transfer_status_object.map(dt => {
                dt.type = "Data Transfer"
            })
            timeline_list.push(iu.data_transfer_status_object)
        })

        training_status.map(ts => {
            ts.type = "Train"
        })
        timeline_list.push(training_status)

        model_initialization_status.map(mi => {
            mi.type = "Build Model"
        })
        timeline_list.push(model_initialization_status)

        label_status.map(ls => {
            ls.type = "Label Samples"
        })
        timeline_list.push(label_status)
        timeline_list = [].concat.apply([], timeline_list)

        timeline_list = timeline_list.sort((a,b) => new Date(b.request_time) - new Date(a.request_time))
        console.log("Timeline list :", timeline_list)
        return timeline_list
    }

    renderTimelineContent = (item) => {
        if (item.type === "Data Transfer") {
            return (
                <Paper variant = 'outlined' style = {{padding : '5px', width : '100%'}}>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Information Unit</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.iu_name}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Serving Web Service</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.serving_ws}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Status</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.status}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Message</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.message}</Typography>
                    </div>
                </Paper>
            )
        } else if (item.type === "Build Model") {
            return (
                <Paper variant = 'outlined' style = {{padding : '5px', width : '100%'}}>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Operation</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.operation}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Stage</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.type}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Namespace</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.namespace}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Status</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.status}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Message</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.message}</Typography>
                    </div>
                </Paper>
            )
        } else if (item.type === "Label Samples") {
            return (
                <Paper variant = 'outlined' style = {{padding : '5px', width : '100%'}}>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Operation</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.operation}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Stage</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.type}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Namespace</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.namespace}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Status</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.status}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Message</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.message}</Typography>
                    </div>
                </Paper>
            )
        } else if (item.type === "Train") {
            return (
                <Paper variant = 'outlined' style = {{padding : '5px', width : '100%'}}>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Operation</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.operation}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Stage</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.type}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Namespace</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.namespace}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Status</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.status}</Typography>
                    </div>
                    <div style = {{marginBottom : '3px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Message</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{item.message}</Typography>
                    </div>
                </Paper>
            )
        }
    }

    renderOppositeContent = (item) => {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

        let request_time = item.request_time !== null ? format(zonedTimeToUtc(format(new Date(item.request_time),'yyyy-MM-dd HH:mm:ss'), timezone), 'do MMM yyyy HH:mm:ss') : "Not Available"
        let end_time = item.end_time !== null ? format(zonedTimeToUtc(format(new Date(item.end_time),'yyyy-MM-dd HH:mm:ss'), timezone), 'do MMM yyyy HH:mm:ss') : "Not Available"

        return (
            <Paper elevation = {2} style = {{display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '5px'}}>
                <div style = {{flexGrow : 1, textAlign : "left", marginRight : '5px'}}>
                    <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Request</Typography>
                    <Typography style = {{display : 'block'}} variant = 'caption'>{request_time}</Typography>
                </div>
                <div>
                    <ArrowRightAlt color = 'primary' fontSize = 'small'/>
                </div>
                <div style = {{flexGrow : 1, textAlign : "right", marginLeft : '5px'}}>
                    <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>End</Typography>
                    <Typography style = {{display : 'block'}} variant = 'caption'>{end_time}</Typography>
                </div>
            </Paper>
        )
    }

    renderTimelineDot = (item) => {
        let color = item.status !== null ? state_colors[item.status].color : state_colors['Dirty'].color
        if (item.type === "Data Transfer") {
            return (
                <TimelineDot style = {{backgroundColor : color}}>
                    <Tooltip title = {item.type}>
                        {
                            React.createElement(stages[item.type].icon, {
                                style : {
                                    color : '#FFFFFF'
                                },
                                fontSize : 'small'
                            })
                        }
                    </Tooltip>
                </TimelineDot>
            )
        } else if (item.type === "Build Model") {
            return (
                <TimelineDot style = {{backgroundColor : color}}>
                    <Tooltip title = {item.type}>
                        {
                            React.createElement(stages[item.type].icon, {
                                style : {
                                    color : '#FFFFFF'
                                },
                                fontSize : 'small'
                            })
                        }
                    </Tooltip>
                </TimelineDot>
            )
        } else if (item.type === "Label Samples") {
            return (
                <TimelineDot style = {{backgroundColor : color}}>
                    <Tooltip title = {item.type}>
                        {
                            React.createElement(stages[item.type].icon, {
                                style : {
                                    color : '#FFFFFF'
                                },
                                fontSize : 'small'
                            })
                        }
                    </Tooltip>
                </TimelineDot>
            )
        } else if (item.type === "Train") {
            return (
                <TimelineDot style = {{backgroundColor : color}}>
                    <Tooltip title = {item.type}>
                        {
                            React.createElement(stages[item.type].icon, {
                                style : {
                                    color : '#FFFFFF'
                                },
                                fontSize : 'small'
                            })
                        }
                    </Tooltip>
                </TimelineDot>
            )
        } 
    }

    renderTimeline = () => {
        const { classes } = this.props
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        let timeline_list = this.getTimeLineObject()

        let timeline = timeline_list.map(item => {
            return (
                <TimelineItem>
                    <TimelineOppositeContent>
                        {this.renderOppositeContent(item)}
                    </TimelineOppositeContent>
                    <TimelineSeparator color = 'primary'>
                        {this.renderTimelineDot(item)}
                        <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent style = {{flexGrow : 2}}>
                        {this.renderTimelineContent(item)}
                    </TimelineContent>
                </TimelineItem>
            )
        })

        return timeline
    }

    renderICCreationTime = () => {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        let request_time = format(zonedTimeToUtc(format(new Date(this.props.ic.created_date),'yyyy-MM-dd HH:mm:ss'), timezone), 'dd/MM/yyyy HH:mm:ss')
        return (
            <TimelineItem>
                <TimelineOppositeContent>
                <Paper elevation = {2} style = {{display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '5px'}}>
                    <div style = {{textAlign : "left", marginRight : '5px'}}>
                        <Typography style = {{display : 'block'}} variant = 'caption' color = 'primary'>Request</Typography>
                        <Typography style = {{display : 'block'}} variant = 'caption'>{request_time}</Typography>
                    </div>
                </Paper>
                </TimelineOppositeContent>
                <TimelineSeparator color = 'primary'>
                    <TimelineDot style = {{backgroundColor : "#0bb5b0"}}>
                        <DeviceHub style = {{color : '#FFFFFF'}} fontSize = 'small'/>
                    </TimelineDot>
                </TimelineSeparator>
                <TimelineContent style = {{flexGrow : 2}}>
                    <Paper variant = 'outlined' style = {{padding : '5px', width : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignContent : 'center'}}>
                        <Typography variant = 'caption' color = 'primary'>{this.props.ic.name + " was created succesfully"}</Typography>
                    </Paper>
                </TimelineContent>
            </TimelineItem>
        )
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', height : '100%'}}>
                    <div style = {{width : '100%'}}>
                        <Timeline>
                            {this.renderTimeline()}
                            {this.renderICCreationTime()}
                        </Timeline>
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(TimeLine);